import { render, staticRenderFns } from "./QueueEditModal.vue?vue&type=template&id=354b1d44&scoped=true"
import script from "./QueueEditModal.vue?vue&type=script&lang=js"
export * from "./QueueEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354b1d44",
  null
  
)

export default component.exports